import { RefObject, useEffect } from 'react';

const useOutsideClick = (ref: RefObject<HTMLElement | null>, isActive: boolean, onOutsideClick?: () => void) => {
    useEffect(() => {
        if (!onOutsideClick) {
            return;
        }

        const handleClickOutside = (event: MouseEvent) => {
            const isRightMouseButton = event.button === 2;
            if (event.type === 'mousedown' && isRightMouseButton) {
                return;
            }

            if (isActive && ref.current && event.target instanceof Node && !ref.current.contains(event.target)) {
                onOutsideClick();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return (): void => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref, isActive, onOutsideClick]);
};

export default useOutsideClick;
